export const validateZipCode = (zipCode: string | undefined): boolean =>
  validateUSZipCode(zipCode) || validateCANPostalCode(zipCode);

export const validateUSZipCode = (zipCode: string | undefined): boolean =>
  !!(zipCode && /^\d{5}$/.test(zipCode));

export const validateCANPostalCode = (zipCode: string | undefined): boolean =>
  !!(
    zipCode &&
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/.test(
      zipCode
    )
  );
